import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { actions as formActions } from 'react-redux-form';
import { FormattedText } from 'core/i18n';
import stepsActions from 'actions/stepsActions';
import mapActions from 'actions/mapActions';
import SimpleMap from 'components/map/map';
import { DocumentationRequired } from './documentationRequired';
import FeatureTogglingRender from 'components/featureToggling/featureTogglingRender';
import { recordEvent, PAGE_PRODUCT } from 'utilities/uTagging';
import scroll from 'utilities/scroll';
import getEncrypted from 'utilities/getEncrypted';
import { showDependsOnTwoFlags } from 'utilities/flags';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import { PATH_IDENTITY_POST_OFFICE, PATH_IDENTITY_POST_OFFICE_EVENT } from 'constants/uTagConstants/paths';
import { EVENT_ONBOARDING } from 'constants/uTagConstants/RAConstants';
import { PHYSICALIDEN, COURIER } from 'constants/featureFlagging';
import { isMobile } from 'utilities/browser';

class OfficeIdentification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            scroll: false,
        };

        this.handleShowMap = this.handleShowMap.bind(this);
        this.handleScrollStatus = this.handleScrollStatus.bind(this);
    }

    componentDidMount() {
        const { userProfile, mapActions, method } = this.props;
        const identitybuttonElement = document.getElementById('identityButton');
        mapActions.hideMap();

        recordEvent(
            PATH_IDENTITY_POST_OFFICE,
            PAGE_PRODUCT,
            PATH_IDENTITY_POST_OFFICE_EVENT,
            'correo',
            userProfile.recordId,
            userProfile.userId,
            '',
            userProfile.investmentType,
            getEncrypted(userProfile.docNumber),
            {
                categoriaEvento: EVENT_ONBOARDING,
                accionEvento: PATH_IDENTITY_POST_OFFICE_EVENT,
                etiquetaEvento: 'correo',
            }
        );

        if (isMobile() && method !== '') {
            scroll.transition(identitybuttonElement, 'percentage', 0.7, 500);
        }
    }

    componentDidUpdate() {
        const mapElement = document.getElementById('map');

        if (this.state.scroll && this.props.map.get('showMap')) {
            scroll.transition(mapElement, 'percentage', 0.98, 0);
            this.handleScrollStatus(false);
        }
    }

    handleShowMap() {
        this.props.mapActions.showMap();
        this.handleScrollStatus(true);
    }

    handleScrollStatus(value) {
        this.setState({ scroll: value });
    }

    render() {
        const classButtonShowMap = this.props.map.get('showMap') ? 'hidden' : 'form__button form__button-secondary';
        const map = this.props.map.get('showMap') ? (
            <SimpleMap
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBZzJfZ9AcdRxMHn7CTRCnxkWXm5ehki0E&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `400px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
            />
        ) : null;

        return (
            <div className="post-officer">
                <div className="row">
                    <div className="col-xs-12 col-sm-6">
                        <FeatureTogglingRender
                            notAllowedProductKey={flags => showDependsOnTwoFlags(flags, COURIER, PHYSICALIDEN)}
                        >
                            <p className="font-heading6">
                                <FormattedText value="identity-removeInPostOffice" />
                            </p>
                        </FeatureTogglingRender>
                        <p className="font-paragraph2">
                            <FormattedText value="identification-postOfficeDescription1" />
                        </p>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <p className="font-paragraph2 font-paragraph2--semibold">
                            <FormattedText value="identity-postOfficeValidation" />
                        </p>
                        <DocumentationRequired />
                    </div>
                </div>
                <div>
                    <button
                        type="button"
                        id="identityButton"
                        onClick={this.handleShowMap}
                        className={classButtonShowMap}
                    >
                        <FormattedText value="button-selectOffice" />
                    </button>
                </div>
                <div className="row" id="map">
                    <div className="col-xs-12">{map}</div>
                </div>
            </div>
        );
    }
}

module.exports.constructor = OfficeIdentification;
module.exports.OfficeIdentification = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        map: state.map,
        immStepsState: state.steps,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        mapActions: bindActionCreators(mapActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
    })
)(withFeatureToggling(OfficeIdentification));

OfficeIdentification.defaultProps = {
    method: '',
};

OfficeIdentification.propTypes = {
    method: PropTypes.string,
};
